/*
 * vision-jq-shim.js
 * Substituto mínimo de jQuery em JavaScript puro.
 *
 * Propósito: os snippets de checkout transparente (YampiSnippet e VDACheckout)
 * foram escritos usando jQuery, mas o tema Vision (base Horizon) NÃO usa jQuery
 * em nenhuma outra parte. Em vez de carregar a biblioteca completa (~90 KB,
 * parser-blocking, de CDN externo) este shim implementa SOMENTE os métodos
 * que aqueles scripts realmente chamam:
 *
 *   $(seletor) / $(elemento) / $(window) / $(document)
 *   .not(seletor)      .hide()           .each(fn)
 *   .attr(nome[,valor]) .removeAttr(nome) .addClass(cls)
 *   .on(evento, fn)    .parents(seletor) .serialize()
 *   .length            (propriedade)     index [n] (acesso ao elemento bruto)
 *
 * Os scripts de checkout já fazem `if (window.$ || window.jQuery)`, então
 * basta expor window.$ e window.jQuery apontando para este shim.
 *
 * Tamanho: ~2 KB sem minificar. Carregado localmente (sem dependência de CDN).
 */
(function () {
  'use strict';

  // Evita sobrescrever um jQuery real, caso algum app de terceiros já tenha carregado um.
  if (window.jQuery && window.jQuery.fn) return;

  function toArray(input) {
    if (input == null) return [];
    if (input === window || input === document) return [input];
    if (input.nodeType) return [input];                       // elemento único
    if (typeof input === 'string') {
      // ':first' não é seletor CSS válido; trata o caso usado pelos scripts
      if (input.indexOf(':first') !== -1) {
        var base = input.replace(':first', '').trim();
        var first = document.querySelector(base);
        return first ? [first] : [];
      }
      return Array.prototype.slice.call(document.querySelectorAll(input));
    }
    if (input instanceof JQ) return input.elements.slice();
    if (typeof input.length === 'number') return Array.prototype.slice.call(input);
    return [input];
  }

  function JQ(input) {
    this.elements = toArray(input);
    this.length = this.elements.length;
    // Permite acesso por índice: coleção[0]
    for (var i = 0; i < this.elements.length; i++) this[i] = this.elements[i];
  }

  JQ.prototype.each = function (fn) {
    for (var i = 0; i < this.elements.length; i++) {
      // jQuery chama fn com `this` = elemento e (index, element) como args
      fn.call(this.elements[i], i, this.elements[i]);
    }
    return this;
  };

  JQ.prototype.not = function (selector) {
    var excluded = toArray(selector);
    var filtered = this.elements.filter(function (el) {
      // remove se o elemento bater no seletor OU estiver na lista excluída
      if (typeof selector === 'string') {
        try { if (el.matches(selector)) return false; } catch (e) {}
      }
      return excluded.indexOf(el) === -1;
    });
    return new JQ(filtered);
  };

  JQ.prototype.hide = function () {
    this.elements.forEach(function (el) { el.style.display = 'none'; });
    return this;
  };

  JQ.prototype.addClass = function (classes) {
    var list = String(classes).split(/\s+/).filter(Boolean);
    this.elements.forEach(function (el) {
      list.forEach(function (c) { el.classList.add(c); });
    });
    return this;
  };

  JQ.prototype.removeClass = function (classes) {
    var list = String(classes).split(/\s+/).filter(Boolean);
    this.elements.forEach(function (el) {
      list.forEach(function (c) { el.classList.remove(c); });
    });
    return this;
  };

  JQ.prototype.attr = function (name, value) {
    if (value === undefined) {
      // getter: retorna do primeiro elemento (como jQuery)
      return this.elements.length ? this.elements[0].getAttribute(name) : undefined;
    }
    this.elements.forEach(function (el) { el.setAttribute(name, value); });
    return this;
  };

  JQ.prototype.removeAttr = function (name) {
    this.elements.forEach(function (el) { el.removeAttribute(name); });
    return this;
  };

  JQ.prototype.on = function (eventName, handler) {
    this.elements.forEach(function (el) {
      el.addEventListener(eventName, handler);
    });
    return this;
  };

  JQ.prototype.parents = function (selector) {
    var matched = [];
    this.elements.forEach(function (el) {
      var p = el.parentElement;
      while (p) {
        if (!selector || p.matches(selector)) {
          if (matched.indexOf(p) === -1) matched.push(p);
        }
        p = p.parentElement;
      }
    });
    return new JQ(matched);
  };

  // serialize() de um <form> no formato application/x-www-form-urlencoded
  JQ.prototype.serialize = function () {
    var form = this.elements[0];
    if (!form || form.tagName !== 'FORM') return '';
    var params = new URLSearchParams(new FormData(form));
    return params.toString();
  };

  // Factory exposta como $(...)
  function $(input) { return new JQ(input); }
  $.fn = JQ.prototype;

  window.$ = $;
  window.jQuery = $;
})();
